import React, { useCallback } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import StyledSearchInput from './styles';
import useDebounce from '../../hooks/useDebounce';

interface SearchInputProps {
  onSearch: (value: string) => void;
  placeholder?: string;
  delay?: number;
}

const SearchInput = React.memo(
  ({ onSearch, placeholder = 'Procurar...', delay = 500 }: SearchInputProps) => {
    const debouncedSearch = useDebounce(onSearch, delay);

    const handleChange = useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        debouncedSearch(newValue);
      },
      [debouncedSearch]
    );

    return (
      <StyledSearchInput
        variant="standard"
        size="medium"
        placeholder={placeholder}
        onChange={handleChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" sx={{ color: '#666', mr: 0.5 }} />
            </InputAdornment>
          ),
        }}
      />
    );
  }
);

SearchInput.displayName = 'SearchInput';

export default SearchInput;
